import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Link as MaterialLink } from '@material-ui/core';
import Menu from './Menu';
import Button from '@material-ui/core/Button';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import jwt from 'jsonwebtoken';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';
import { EVENT_ID, EVENT_IMG, EVENT_NAME, getUserID, LOGIN_TB, SIGNOUT_URL, tokenRefresh } from '../constants';
import MainContext from '../MainContext';
// import EMAlert from './EMAlert';
import IoTClient from '../lib/iot-client';
import SocketManager from './SocketManager';
import ProgramDialog from '../program/ProgramDialog';

import { ImCalendar } from 'react-icons/im';
import { IoMdCheckboxOutline } from 'react-icons/io';
import Stack from '@mui/material/Stack';

const moment = require('moment');

Amplify.configure(awsconfig);

const styles = (theme) => ({
  appBar: {
    position: 'relative',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey['100']}`,
    backgroundColor: '#FFFFFF',
  },
  toolBar: {
    // minHeight: 84,
    // height: '100%',
    height: 84,

    backgroundColor: '#FFFFFF',
    '& .MuiTabs-root': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },

  flex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },

  tagline: {
    display: 'inline-block',
    marginLeft: 10,
    [theme.breakpoints.up('md')]: {
      paddingTop: '0.8em',
    },
  },
  iconContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconButton: {
    float: 'right',
  },
  tabContainer: {
    marginLeft: 32,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tabItem: {
    textTransform: 'none',
    paddingTop: 10,
    paddingBottom: 10,
    // minWidth: 100,
    minWidth: '8vw',

    minHeight: 84,
    // fontSize: 'large',
    fontSize: '1.25rem',
    // '&.MuiTab-textColorPrimary.Mui-selected': {
    //   backgroundColor: 'rgba(71,172,136,0.1)',
    // },
  },
});

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    paddingTop: 10,
    paddingBottom: 10,
    minWidth: '8vw',
    minHeight: 84,
    fontSize: '1.25rem',
    [theme.breakpoints.down('lg')]: {
      minWidth: '7vw',
      fontSize: '1.1rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  },
}))((props) => <Tab disableRipple {...props} />);

class Topbar extends Component {
  static contextType = MainContext;

  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      menuDrawer: false,
      username: '',
      mainSocket: null,
      eventInfo: sessionStorage.getItem('Item') ? JSON.parse(sessionStorage.getItem('Item')) : null,
      isIE: null,
      programDialog: false,
      matches: window.matchMedia('(max-width:992px)').matches,
    };

    this.logout = this.logout.bind(this);
    if (!sessionStorage.getItem('_in_user_')) {
      this.props.history.push('signin');
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  mobileMenuOpen = (event) => {
    this.setState({ menuDrawer: true });
  };

  mobileMenuClose = (event) => {
    this.setState({ menuDrawer: false });
  };

  logout() {
    if (sessionStorage.getItem('_in_name')) {
      fetch(
        `${SIGNOUT_URL}?username=${encodeURIComponent(
          sessionStorage.getItem('_in_name'),
        )}&userid=${getUserID()}&evt=${EVENT_ID}&tbName=${LOGIN_TB}&agent=${encodeURIComponent(navigator.userAgent)}`,
        {
          method: 'GET',
        },
      )
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }

    try {
      const mqClient = new IoTClient();
      mqClient.disconnect();
    } catch (e) {}

    localStorage.clear();
    sessionStorage.clear();
    Auth.signOut().then(() => {
      this.props.history.push('/');
    });
  }

  componentDidMount() {
    const agent = navigator.userAgent.toLowerCase();
    if ((navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1) || agent.indexOf('msie') !== -1) {
      this.setState({ isIE: 'Y' });
    } else {
      this.setState({ isIE: 'N' });
    }
    window.name = EVENT_NAME; //live에서 프로그램 오픈하기 위해서 window 이름 설정
    try {
      this.setState({
        username: sessionStorage.getItem('_in_name'),
      });
    } catch (e) {
      console.error(e);
    }

    window.scrollTo(0, 0);

    // check token expire
    const decoded = jwt.decode(sessionStorage.getItem('_in_jwt'));
    if (decoded) {
      console.log(
        'tokenExp',
        moment(decoded.exp * 1000)
          .tz('Asia/Seoul')
          .format('YYYY-MM-DD HH:mm:ss'),
      );
      const exp = moment(decoded.exp * 1000);
      const now = moment();
      const diff = exp.diff(now, 'minutes');
      console.log(`토근 만료까지 ${diff}분 남았습니다.`);
      if (diff < 10) tokenRefresh().then((r) => {});
    }

    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').addListener(handler);
  }

  componentWillUnmount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').removeListener(handler);
  }

  current = () => {
    const MenuArray = Menu.map((el) => el.pathname);
    const PathName = this.props.history.location.pathname;
    if (MenuArray.indexOf(PathName) === -1) {
      return null;
    } else {
      return MenuArray.indexOf(PathName);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <AppBar position="static" color="default" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <Grid container style={{ height: '100%' }} item xs={12}>
            <Stack direction="row" justifyContent={'space-between'} style={{ height: '100%', width: '100%' }}>
              {/* logo & Tab Grid >>> */}
              <Grid container alignItems="center">
                <Grid item xs={12} md={5} style={{ width: 'fit-content' }}>
                  <Link to="/main" style={{ height: '80px', width: '100%' }}>
                    <Grid
                      container
                      justifyContent="center"
                      alignContent="center"
                      style={{
                        maxHeight: '80px',
                        width: '100%',
                        backgroundColor: '#C0E9E2',
                        borderRadius: '20px',
                        padding: '10px 20px',
                        // alignContent: 'center',
                      }}
                    >
                      <img
                        src={`${EVENT_IMG}/topbar_logo_text.png`}
                        alt="img"
                        className={classes.logo}
                        style={{
                          maxHeight: '80px',
                          width: this.state.matches ? '90%' : '21vw',
                          // marginTop: this.state.matches ? '10px' : 0,
                        }}
                      />
                    </Grid>
                  </Link>
                </Grid>
                <Grid item md={7}>
                  {!this.props.noTabs && (
                    <div
                    // style={{ marginLeft: '16px' }}
                    >
                      {window.matchMedia('(max-width:1600px)').matches && (
                        <SwipeableDrawer
                          anchor="right"
                          open={this.state.menuDrawer}
                          onClose={this.mobileMenuClose}
                          onOpen={this.mobileMenuOpen}
                        >
                          <AppBar title="Menu" />
                          <List>
                            {Menu.map((item, index) => (
                              <ListItem
                                component={item.external ? MaterialLink : Link}
                                href={item.external ? item.pathname : null}
                                to={
                                  item.external
                                    ? null
                                    : {
                                        pathname: item.pathname,
                                        search: this.props.location.search,
                                      }
                                }
                                button
                                key={item.label}
                              >
                                <ListItemText primary={item.label} />
                              </ListItem>
                            ))}

                            <Grid
                              container
                              justifyContent="center"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                window.open('http://pf.kakao.com/_Zxkbab');
                              }}
                            >
                              <img src={`${EVENT_IMG}/kakao_logo.png`} alt={'kakao'} style={{ height: 30 }} />
                            </Grid>
                          </List>
                          <Button
                            size={'small'}
                            color={'primary'}
                            variant={'contained'}
                            disableElevation
                            onClick={this.logout}
                            style={{ margin: '0 10px', textTransform: 'none', color: '#fff' }}
                          >
                            Logout
                          </Button>
                        </SwipeableDrawer>
                      )}

                      {/* Tab 영역 web>>> */}
                      {
                        !window.matchMedia('(max-width:992px)').matches && (
                          <Tabs
                            value={this.current() || this.props.currentPath || this.state.value}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleChange}
                          >
                            {Menu.map((item, index) => (
                              <StyledTab
                                key={index}
                                component={item.external ? MaterialLink : Link}
                                href={item.external ? item.pathname : null}
                                to={
                                  item.external
                                    ? null
                                    : {
                                        pathname: item.pathname,
                                        search: this.props.location.search,
                                      }
                                }
                                // classes={{ root: classes.tabItem }}
                                label={item.label}
                              />
                            ))}
                          </Tabs>
                        )
                        /* <<<<Tab 영역 web */
                      }
                    </div>
                    // </React.Fragment>
                  )}
                </Grid>
              </Grid>

              {/* <<< logo & tab grid */}

              {/* name & login button grid >>> */}

              <Grid style={{ height: '100%' }}>
                <Stack direction={'row'} justifyContent="center" alignItems="center" style={{ height: '100%' }}>
                  {!window.matchMedia('(max-width:1600px)').matches && (
                    <>
                      <Grid>
                        <Button
                          size={'small'}
                          color={'primary'}
                          startIcon={<IoMdCheckboxOutline size={20} />}
                          variant={'outlined'}
                          disableElevation
                          onClick={() => {
                            this.props.history.push('mypage');
                          }}
                          style={
                            window.matchMedia('(max-width:1600px)').matches
                              ? { display: 'none' }
                              : { height: 40, textTransform: 'none', width: '120px' }
                          }
                        >
                          My page
                        </Button>
                      </Grid>
                      <Grid>
                        <Button
                          size={'small'}
                          variant={'outlined'}
                          startIcon={<ImCalendar size={20} />}
                          disableElevation
                          onClick={() => {
                            this.setState({ programDialog: true });
                          }}
                          style={
                            window.matchMedia('(max-width:1600)').matches
                              ? { display: 'none' }
                              : {
                                  margin: '0 10px',
                                  height: 40,
                                  textTransform: 'none',
                                  borderColor: 'rgb(137,147,176)',
                                  width: '120px',
                                  lineHeight: 1.2,
                                }
                          }
                        >
                          VOD
                          <br /> 다시보기
                        </Button>
                      </Grid>
                      <Grid
                        container
                        alignContent="center"
                        justifyContent="center"
                        style={{ cursor: 'pointer', width: '40px', marginRight: '10px' }}
                        onClick={() => {
                          window.open('https://pf.kakao.com/_Zxkbab');
                        }}
                      >
                        <img
                          src={`${EVENT_IMG}/kakao_logo.png`}
                          alt={'kakao'}
                          style={window.matchMedia('(max-width:1600px)').matches ? { display: 'none' } : { height: 40 }}
                        />
                      </Grid>
                      <Grid container justifyContent="flex-end" style={{ width: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <Typography style={{ textOverflow: 'ellipsis' }}>
                          {this.state.username === 'undefined' ? '' : this.state.username}&nbsp;&nbsp;<b>님</b>
                        </Typography>
                      </Grid>
                      {/*moment(this.context.now).format('HH:mm:ss')*/}
                      <Grid>
                        <Button
                          size={'small'}
                          color={'primary'}
                          variant={'contained'}
                          disableElevation
                          onClick={this.logout}
                          style={
                            window.matchMedia('(max-width:1600)').matches
                              ? { display: 'none' }
                              : {
                                  margin: '0 10px',
                                  textTransform: 'none',
                                  color: '#fff',
                                  height: '40px',
                                  width: '100px',
                                  fontSize: 'large',
                                }
                          }
                        >
                          Logout
                        </Button>
                      </Grid>
                    </>
                  )}
                  {/* 모바일 메뉴버튼 위치 변경 */}
                  <div style={{ display: window.matchMedia('(max-width:1600px)').matches ? 'block' : 'none' }}>
                    <IconButton onClick={this.mobileMenuOpen} className={classes.iconButton} color="inherit" aria-label="Menu">
                      <MenuIcon />
                    </IconButton>
                  </div>
                </Stack>
              </Grid>
            </Stack>
          </Grid>

          {/* <<< name & login button grid */}
        </Toolbar>

        {/*<EMAlert />*/}
        {this.state.eventInfo && this.state.eventInfo.useLoginCheck && <SocketManager />}
        <ProgramDialog
          open={this.state.programDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ programDialog: false });
            }
          }}
          // onClose={() => this.setState({ programDialog: false })} disableBackdrop={false}
        />
      </AppBar>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Topbar));
